<template>
  <div class="container1 flex flex-col items-center justify-center">
    <div align="center" class="w-full">
      <div class="open_email" style="margin-left: 8px; margin-top: 8px; margin-bottom: 8px; margin-right: 8px">
        <div>
          <br />
          <span class="genEmailContent">
            <div
              id="cTMail-Wrap"
              style="
                word-break: break-all;
                box-sizing: border-box;
                text-align: center;
                min-width: 320px;
                max-width: 500px;
                border: 1px solid #f6f6f6;
                background-color: #faf8f7;
                margin: auto;
                padding: 20px 0 30px;
                font-family: 'helvetica neue', PingFangSC-Light, arial, 'hiragino sans gb', 'microsoft yahei ui',
                  'microsoft yahei', simsun, sans-serif;
              "
            >
              <div class="main-content" style="">
                <table style="width: 100%; font-weight: 300; margin-bottom: 10px; border-collapse: collapse">
                  <tbody>
                    <tr style="font-weight: 300">
                      <td style="width: 3%; max-width: 30px"></td>
                      <td style="max-width: 500px">
                        <div id="cTMail-logo" style="width: 160px">
                          <a href="javascript:;">
                            <img v-if="logoSrc" border="0" :src="logoSrc" style="width: 160px; display: block" />
                          </a>
                        </div>
                        <p
                          style="
                            height: 2px;
                            background-color: #161c2a;
                            border: 0;
                            font-size: 0;
                            padding: 0;
                            width: 100%;
                            margin-top: 20px;
                          "
                        ></p>

                        <div
                          id="cTMail-inner"
                          style="
                            background-color: #fff;
                            padding: 23px 0 20px;
                            box-shadow: 0px 1px 1px 0px rgba(122, 55, 55, 0.2);
                            text-align: left;
                          "
                        >
                          <table
                            style="
                              width: 100%;
                              font-weight: 300;
                              margin-bottom: 10px;
                              border-collapse: collapse;
                              text-align: left;
                            "
                          >
                            <tbody>
                              <tr style="font-weight: 300">
                                <td style="width: 3.2%; max-width: 30px"></td>
                                <td style="max-width: 480px; text-align: left">
                                  <!-- <h1
                                      id="cTMail-title"
                                      style="font-size: 20px; line-height: 36px; margin: 0px 0px 22px"
                                    >
                                      恭喜你！你已成功預約 。
                                    </h1> -->

                                  <div :class="['box']">
                                    <div class="icon-box">
                                      <i class="el-icon-success icon-check"></i>
                                    </div>
                                    <div :class="[isMobile ? 'success-mobile' : 'success']" class="text-center">
                                      {{ $t('home.submitted_') }}
                                    </div>
                                  </div>
                                </td>
                                <td style="width: 3.2%; max-width: 30px"></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </td>
                      <td style="width: 3%; max-width: 30px"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
    <div class="mt-5 underline">
      <router-link :to="backLink">{{ $t('home.back') }}</router-link>
    </div>
  </div>
  <!-- <div class="mt-[200px] text-center text-[30px]" >你的序号异常，请确定正常的序号。</div> -->
</template>

<script>
import { motorShowCusRentCarUserInfoApi } from '@/Api/requestApi'
import moment from 'moment'

export default {
  name: 'SubmittedSuccess',
  data() {
    return {
      isMobile: false,
      screenWidth: window.innerWidth,
      v: '',
      user: '',
      dialogVisible2: false,
      logoSrc: '',
    }
  },
  computed: {
    backLink() {
      const lang = ['繁體中文', 'Traditional Chinese'].includes(this.user.language) ? 'zh' : 'en'
      const path = this.user.url ? this.user.url : '/'
      return { path, query: { lang } }
    },
  },
  filters: {
    formatDate(value) {
      return moment(value).format('YYYY-MM-DD')
    },
  },
  mounted() {
    // let lang = window.sessionStorage.getItem("sessionLang") || "zh";
    // console.log("不存在 :>> sessionStorage", lang);
    // this.$i18n.locale = lang;
    window.addEventListener('resize', this.handleResize)

    if (this.$route.query.v == '' || this.$route.query.v == undefined) {
      this.dialogVisible2 = true

      setTimeout(() => {
        this.dialogVisible2 = false
        // this.$router.push({ path: '/' })
      }, 2000)
    } else {
      this.dialogVisible2 = true

      this.v = this.$route.query.v
      // console.log('1111111', this.$route.query.v)
      this.userInfo(this.v)
    }
  },
  //   onUnmounted(() => {
  //   window.removeEventListener('resize', handleResize);
  // })
  methods: {
    async userInfo(v) {
      const {
        data: { code, data },
      } = await motorShowCusRentCarUserInfoApi({ strId: v })
      console.log('code', code, data)
      if (code == 200) this.user = data
      console.log('this.user', this.user)
      this.logoSrc = this.user.brand === '' ? '' : require(`@/assets/img/logo_${this.user.brand}.png`)
      if (code) this.dialogVisible2 = false
    },
    handleResize() {
      console.log('handleResize :>> ')
      this.screenWidth = window.innerWidth
      if (this.screenWidth < 750) {
        this.isMobile = true
      } else {
        this.isMobile = false
      }
    },
    // testFn() {
    //   this.$i18n.locale = "en";
    // },
  },
}
</script>

<style lang="scss" scoped>
.container1 {
  height: 100%;
  text-align: center;
  position: relative;
  overflow: hidden;

  // background-color: #f5f5f5;
  .box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // width: 210px;
    width: 100%;
    // position: absolute;
    // top: 40%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // max-width: 510px;
    padding: 45px 0 65px;
    border-radius: 8px;
    // box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
    background-color: #fff;
  }

  .icon-check {
    font-size: 100px;
    // font-size: 60px;
    font-weight: 600;
    color: #85ce61;
  }

  // ------------------------ 手机，小屏**start ------------------------
  .success-mobile {
    padding-top: 15px;
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }

  // ------------------------ 手机，小屏**end ------------------------
  .success {
    padding-top: 16px;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
    color: #333;
  }

  .icon-box {
    // max-width: 90px;
    margin: 0px auto 10px;
    color: #78c440;
  }
}

@import 'element-ui/lib/theme-chalk/display.css';

.img {
  object-fit: cover;
}

::v-deep .el-dialog {
  border-radius: 10px !important;
  background: none !important;
  background-color: rgba(000, 000, 000, 0.6) !important;
}

.contaier {
  .top-nvb_box {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    border-bottom: #ccc solid 1px;
    z-index: 1000;
    background-color: #fff;

    .top-nvb {
      position: relative;
      max-width: 1200px;
      margin: 0 auto;
      padding: 20px 0;

      .logo-box {
        max-width: 120px;
        margin: 0 auto;
      }

      .lang {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translate(0%, -50%);
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }

  .dialog-box {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .icon-check {
      font-size: 60px;
      font-weight: 600;
      color: #fff;
    }

    .title {
      padding-top: 10px;
      font-size: 16px;
      color: #fff;
    }
  }

  .dialog-box2 {
    padding-top: 5px;
    padding-bottom: 30px;
  }
}
</style>
